import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
// import { Article } from '../shared/article.model';
// import { ArticleService } from "../shared/article.service";
import { Article, ArticleService, Category } from '../shared';
import { PaginationInstance } from "ngx-pagination/dist/ngx-pagination";
import { NewsDocument } from '../shared/news-document.model';

@Component({
  selector: 'bp-article-lists',
  templateUrl: 'article-list.component.html'
})

export class ArticleListComponent implements OnDestroy, OnInit {

  public config: PaginationInstance = {
    id: 'custom',
    itemsPerPage: 10,
    currentPage: 1
  };
  categories: Category[];
  category: Category;
  articles: Article[];
  filteredArticles = this.articles;
  title: string = "";
  documents: NewsDocument[] = [];
  private id: any;
  private catId: any;

  constructor(
    private articleService: ArticleService,
    private route: ActivatedRoute,
    private router: Router,
  ) { }

  ngOnInit() {

    this.route
      .params.subscribe(params => {
        this.catId = +params['id']

        if (this.catId) {
          this.getArticles();
          this.getDocuments();
        } else {
        }
      });

    this.route
      .queryParams.subscribe(qparams => {
        this.config.currentPage = (qparams && +qparams['page']) || 1;

      });


    //.map(params => params['id'])
    //.do(id => this.catId = +id)
    //.subscribe(id => {
    //  if (this.catId) {
    //    this.getArticles();
    //  }else{

    //   this.router.navigateByUrl(`/news`);
    //  }

    //});
  }

  ngOnDestroy(): void {

  }

  private getDocuments(): void {
    this.documents = [];
    this.articleService.getDocuments(this.catId)
      .subscribe(documents => {
        this.documents = documents;
      });
  }

  getNewsCateogry() {
    this.articleService.getCategory(this.catId)
      .subscribe(category => {
        this.category = category;
      });
  }

  getArticles() {


    this.articleService.getArticles(this.catId)
      .subscribe(articles => {
        this.articles = [];
        this.articles = this.filteredArticles = articles;
        if (articles[0].contentTypeName == 'Građani'){
          articles[0].contentTypeName = 'Učešće građana u budžetskom procesu';
        }
        if (articles[0].contentTypeName == 'Грађани'){
          articles[0].contentTypeName = 'Учешће грађана у буџетском процесу'
        }
      });
  }

  pageChanged(event: any) {
   // console.log('page change event ', event);
    this.config.currentPage = event;
    this.router.navigate([], { queryParams: { page: this.config.currentPage } });
    //(pageChange) = "config.currentPage = $event"
  }

}



// WEBPACK FOOTER //
// ./src/app/news/article-list/article-list.component.ts